module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="widget-toolbox-container ';
 if (spectatorMode) { ;
__p += ' spectator-mode';
 } ;
__p += '"></div>\n<div class="settings-sidebar">\n    <section class="experience-settings-container" />\n    <section class="behaviors-properties" />\n    <section class="widget-controls" />\n    <section class="widget-tab-order-container" />\n    <section class="widget-layer-order-container" />\n    <section class="widget-order-control" />\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/WidgetToolboxView.tpl
// module id = 3022
// module chunks = 0